module.exports = __webpack_public_path__ + "img/myself01-web.696ca4e9.png";